import { SUPPORTED_LANGUAGES } from '@/api/types'
import { useAppLocale as useAppLocaleLib } from '@deepcloud/deep-ui-lib'
import type { SupportedLanguage } from '@/api/types'

const LOCALSTORAGE_KEY = 'locale'

export const useAppLocale = createGlobalState(() => {
  const { setAppLocale } = useAppLocaleLib()

  function getUserLanguage() {
    // Check if a locale is stored in localStorage
    const storedLocale = localStorage.getItem(LOCALSTORAGE_KEY)

    if (storedLocale) {
      // If a locale is stored, use it
      return storedLocale
    }

    const userLanguages = navigator.languages

    for (const lang of userLanguages) {
      const languageCode = lang.split('-')[0] // Get the language code from the language tag
      if (SUPPORTED_LANGUAGES.includes(languageCode as SupportedLanguage)) {
        return languageCode
      }
    }

    return import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'de'
  }

  function setInitialAppLanguage() {
    setAppLocale(getUserLanguage())
  }

  function changeAppLanguage(lang: string) {
    const newLang = setAppLocale(lang)
    localStorage.setItem(LOCALSTORAGE_KEY, newLang)
  }

  return { setInitialAppLanguage, changeAppLanguage }
})
